export const stringToColor = (username: string) => {
    let hash = 0;
    let i;

    for (i = 0; i < username.length; i += 1) {
        hash = username.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
};
